<template>
  <BaseQuotedMessage
    class="q-mb-sm cursor-pointer"
    :message="normalizedMessage"
    :contact-name="contactName"
    @click="$emit('scroll-to-parent')"
  />
</template>

<script>
import BaseQuotedMessage from './BaseQuotedMessage.vue'

export default {
  name: 'AttendanceChatQuotedMessage',
  components: { BaseQuotedMessage },
  props: {
    message: {
      type: [Object, String],
      required: true
    },
    contactName: {
      type: String,
      default: ''
    }
  },
  computed: {
    normalizedMessage () {
      if (typeof this.message === 'string') return { message: this.message }
      return this.message || { message: '' }
    }
  }
}
</script>
